/* 🤖 this file was generated by svg-to-ts */
export const kzIconsArrangement: {
  name: 'arrangement';
  data: string;
} = {
  name: 'arrangement',
  data: `<svg viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7.5v-3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2ZM6 6h-.5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2H10a2 2 0 0 1 2 2v.5m0 0a2 2 0 0 0-2 2V20a2 2 0 0 0 2 2h.5a2 2 0 0 0 2-2v-3.5a2 2 0 0 0-2-2H12Z" fill="none" fill-rule="nonzero" stroke="currentColor" stroke-width="1.5px"/></svg>`
};
